
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.533 5.386a2.637 2.637 0 00-3.729 0l7.81 7.81a2.637 2.637 0 000-3.729l-4.081-4.08zM8.365 2.797l-3.09 2.088 3.84 3.84 2.088-3.09-2.838-2.838zM9.298 0a1.758 1.758 0 000 2.486l2.216 2.217c.687.686 1.8.686 2.486 0L9.298 0zM-1.001 14.377l4.776-4.776.621.622-4.776 4.776-.621-.622z","fill":"#8E8E93"}})])
          )
        }
      }
    